import FilterUtils from '@/shared/utils/filters';
import ContractRangeParameterRequest from './contract-range-parameter-request';
import ContractRangeRoleParameter from '../entity/contract-range-role-parameter.entity';

export default class ContractParametersRequest {
  parameterId: string;

  value: any;

  name: string;

  constructor(obj: any = {}) {
    this.parameterId = obj.id || '';
    this.name = obj.name || '';
    this.handleValue(obj);
  }

  public static of(obj: any = {}): ContractParametersRequest {
    return new ContractParametersRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractParametersRequest[] {
    return obj.map(this.of);
  }

  handleValue(obj: any) {
    if (obj.type === 'RANGE' || obj.type === 'RANGE2' || obj.type === 'RANGE_PERCENT'
      || obj.type === 'RANGE_PERCENT2') {
      this.value = [];
      obj.value.forEach((el: ContractRangeParameterRequest) => {
        this.value.push(ContractRangeParameterRequest.of(el))
      });
    } else if (obj.type === 'STRING_LIST_SENIORITY') {
      this.value = [];
      obj.value.forEach((el: any) => {
        this.value.push(ContractRangeRoleParameter.of(el))
      });
    } else if (obj.type === 'MONEY' || obj.type === 'MONEY2' || obj.type === 'PERCENT'
      || obj.type === 'PERCENT2') {
      this.value = parseFloat(FilterUtils.formatValue(obj.value));
    } else if (obj.type === 'LONG') {
      this.value = parseInt(obj.value, 10);
    } else if (obj.type === 'KEY_VALUE' || obj.type === 'KEY_VALUE_PERCENT') {
      this.value = this.convertToObject(obj.value);
    } else if (obj.type === 'STRING_LIST' || obj.type === 'STRING_LIST_ROLE'
      || obj.type === 'BOOLEAN' || obj.type === 'CURRENCY_CONVERT'
    ) {
      this.value = obj.value;
    }
  }

  convertToObject(value: any) {
    const dataObject = Object()
    value.forEach((el: any) => {
      dataObject[el.field] = parseFloat(FilterUtils.formatValue(el.value))
    })
    return dataObject;
  }
}
